<template>
  <v-app id="termsOfService">
    <v-card
      class="mb-6"
      color="lighten-1"
    >
      <v-card-title>利用規約</v-card-title>
      <v-card
        outlined
        height="400"
        width="100%"
        class="overflow-x-hidden overflow-y-auto"
      >
        <div v-if="userType === Constant.UserType.Host">
          <!-- 会計事務所ユーザー向け 利用規約 -->
          <v-row
            dense
            max-width="100"
          >
            <v-col
              cols="12"
              style="font-weight: bold;"
            >
              「以下の利用規約第2条第3項に定めるサブユーザーとしてデータ共有サービスのクラウドフォルダー機能を利用される場合は、以下の利用規約の内容を確認し、サブユーザーとして遵守すべき内容を理解したうえで、ご利用ください。」
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.xs"
              cols="12"
              align="center"
            >
              ＝＝＝＝＝＝＝＝＝＝＝＝＝＝
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.sm"
              cols="12"
              align="center"
            >
              ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.md"
              cols="12"
              align="center"
            >
              ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.lg"
              cols="12"
              align="center"
            >
              ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.xl"
              cols="12"
              align="center"
            >
              ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
            </v-col>
            <v-col />
            <v-col
              cols="12"
              align="center"
              style="font-weight: bold;"
            >
              「Weplatデータ共有サービス(有償)」利用規約
            </v-col>
            <v-col />
            <v-col
              cols="12"
            >
              セイコーエプソン株式会社およびエプソン販売株式会社（以下総称して「エプソン」といいます）は、以下の利用規約（以下「本利用規約」といいます）に基づき、「Weplatデータ共有サービス(有償)」（以下「本サービス」といいます）を提供いたします。
            </v-col>

            <v-col
              v-if="$vuetify.breakpoint.xs"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.sm"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・・・・・・・・・・・・・・・
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.md"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.lg"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.xl"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１条（利用申込み）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本サービスの利用を希望されるお客様は、本利用規約を注意してお読みいただき、販売代理店が定める方法により本サービスの利用申込みを行なっていただきます。
              この利用申込みをされた時点で、お客様は本利用規約のすべての条件に拘束され、従うことに同意いただいたものとみなさせていただきます。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第２条（本サービスの概要）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本サービスは、エプソンが提供する別紙に掲げる会計システム（以下「会計システム」といいます）の製品登録が完了しているお客様で、かつ第３条の定めに基づき本利用契約が成立したお客様（以下「利用者」といいます）に対し、エプソンが有償にて提供するサービスです。
                </li>
                <li style="list-style-type: '２．';">
                  利用者は、本サービスにより会計システムを用いて出力される会計データおよびその他本サービスで利用可能な電子ファイルをエプソンが運営するサーバー上にインターネットを通じて保存し、これを同じくインターネットを通じて自己の顧問先（エプソンが別途本サービスの利用を許諾した顧問先をいい、その従業員を含みます。以下総称して「顧問先」といいます）と共有等して利用することができます。なお、エプソンは、本利用規約、その他のエプソンの利用規約に対する違反行為等を理由として特定の顧問先に対する本サービスの提供をお断りすることがあります。
                </li>
                <li style="list-style-type: '３．';">
                  利用者は、第１５条第１項定めに従い、自己の従業員（以下「サブユーザー」といいます）に対して、本サービスの利用を許諾することができます。
                </li>
                <li style="list-style-type: '４．';">
                  エプソンは、本サービスについて、利用者の事前の許可なく仕様を変更する場合があります。エプソンは、利用者が本利用規約に同意した時点におけるサービス内容を永続的に保証するものではありません。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第３条（利用契約の成立）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本サービスについての利用契約（以下「本利用契約」といいます）は、次項に定める場合を除き、第１条の利用申込みをエプソンが承諾し、利用申込みをされた利用者に対し本サービスを利用するための設定完了通知を交付したときに成立するものとします。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンは、次の場合には、お客様による利用申込みを承諾しない場合があります。
                  <ol>
                    <li style="list-style-type: '① ';">
                      利用者が、会計システムの製品登録が完了していないとき。
                    </li>
                    <li style="list-style-type: '② ';">
                      利用者が、利用申込みにあたり、虚偽の内容を連絡したとき。
                    </li>
                    <li style="list-style-type: '③ ';">
                      利用者が、過去にエプソンが提供する他のサービスにおける料金未払いや不正使用などにより、エプソンから利用契約の解除または利用停止処分を受けていることが判明したとき。
                    </li>
                    <li style="list-style-type: '④ ';">
                      その他、利用申込みを承諾することが不適切であると合理的に認められる事由があるとエプソンが判断したとき。
                    </li>
                  </ol>
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第４条（本サービスの利用）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本サービスの提供時間は、０：００～２４：００とします。ただし、システムメンテナンスなどのために一時的に本サービスを停止することがあります。この場合、エプソンは利用者に対し、本サービスを停止する日時について事前に告知いたします。
                </li>
                <li style="list-style-type: '２．';">
                  前項にかかわらず、天災地変、停電または回線の不良などの緊急やむを得ない場合には、事前告知を行うことなく本サービスを停止することがあります。
                </li>
                <li style="list-style-type: '３．';">
                  利用者は、本サービスの利用方法に関するサポートを販売代理店から受けることができます。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第５条（利用規約の変更）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本利用規約は、エプソンにより、利用者の承諾を得ることなく変更されることがあります。その場合、エプソンは、利用者に対し変更内容の告知を行います。
                </li>
                <li style="list-style-type: '２．';">
                  変更後の利用規約は、当該利用規約に記載する日から効力を生じ、当該記載日より本サービスの利用条件は、変更後の利用規約によるものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第６条（告知の方法）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本利用規約におけるエプソンから利用者への告知は、本サービスのお知らせ画面への掲載や、利用者への電子メールによる通知、販売代理店を通じた連絡など、エプソンが適当と判断する方法により実施します。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第７条（利用期間）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本サービスの利用期間は、利用者が利用申込みされた販売代理店が別途指定する日までとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第８条（利用料金）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本サービスをご利用いただくには、販売代理店が定める利用料金を販売代理店が定める支払い条件でお支払いいただく必要があります。
                </li>
                <li style="list-style-type: '２．';">
                  利用料金および利用料金のお支払方法は、販売代理店にご確認ください。
                </li>
                <li style="list-style-type: '３．';">
                  一度お支払い頂いた利用料金は第１７条第３項に定める場合を除きいかなる場合といえども返還されません。
                </li>
              </ol>
            </v-col>


            <v-col />
            <v-col
              cols="12"
            >
              第９条（本サービスの利用）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  利用者は、エプソン会計システム「マイページ」のお客様番号およびパスワードを使用して本サービスを利用することができます。利用者は、
                  <a
                    href="https://myoen.epson.jp/customers/sc0100/begin.do"
                    target="_blank"
                    rel="noopener"
                  >『エプソン会計システム「マイページ」利用規約』</a>
                  に従いお客様番号およびパスワードの管理もしくは利用などを行なうものとします。
                </li>
                <li style="list-style-type: '２．';">
                  利用者は、本サービスのうち、「Weplatデータ共有サービス クラウドフォルダー」（以下「クラウドフォルダー」といいます）を利用する場合には、自己のサブユーザーからクラウドフォルダーの管理者およびクラウドフォルダーの使用者を選定し、所定の方法に従い、当該管理者および使用者のユーザーIDおよびパスワードの設定等のユーザー作成手続き（以下「ユーザー作成」といいます。）を行うものとします。（ユーザー作成が完了した管理者を、以下「クラウドフォルダー管理者ユーザー」といい、ユーザー作成が完了した使用者を以下「クラウドフォルダー一般ユーザー」といいます）
                </li>
                <li style="list-style-type: '３．';">
                  利用者は、『エプソン会計システム「マイページ」利用規約』に従いお客様番号およびパスワードの管理もしくは利用などを行なうものとし、また、クラウドフォルダー管理者ユーザーおよびクラウドフォルダー一般ユーザーに対して、善良なる管理者の注意義務をもってユーザーIDおよびパスワードを管理し、利用させるものとします。万一、利用者によるお客様番号およびパスワードの管理もしくは利用が不適切であったこと、またはクラウドフォルダー管理者ユーザーおよびクラウドフォルダー一般ユーザーによるユーザーIDおよびパスワードの管理もしくは利用などが不適切であったことが原因で利用者に不利益が生じた場合であっても、エプソンは一切の責任を負わないものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１０条（ご入力情報の変更）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              利用者は、自己、サブユーザーまたは登録されている顧問先などの情報につき変更が生じた場合には、速やかに所定の方法にて変更していただくものとします。利用者が変更を怠ったことにより、損害を被った場合であっても、エプソンおよび販売代理店は一切責任を負わないものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１１条（個人情報の保護）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              エプソンは、利用者およびサブユーザーによりご登録された個人情報、その他本サービスの提供の過程で知り得た個人情報を、エプソンのホームページ上で別途掲載する
              <a
                href="https://www.epson.jp/products/ac/privacy_statement/weplat.htm"
                target="_blank"
                rel="noopener"
              >『「ウェプラット・クラウドサービス」における個人情報の取扱について（プライバシーステートメント）』</a>
              に従い、取り扱うものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１２条（権利譲渡の禁止）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              利用者は、本サービスの利用者たる資格について、有償・無償を問わず第三者に譲渡または貸与することはできません。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１３条（本サービスの提供区域）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本サービスの提供区域は、日本国内に限定されるものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１４条（システムの管理・責任）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  エプソンは、善良なる管理者の注意義務をもって、本サービスを運営するサーバーなどのシステム（以下「システム」といいます）を維持し、システム上のデータ（以下「保存ファイル」といいます）の保全に努めるものとします。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンは、保存ファイルを利用者の機密情報として善良なる管理者の注意義務をもって管理します。エプソンは、以下の各号に定める場合を除き、保存ファイルの内容を閲覧いたしません。
                  <ol>
                    <li style="list-style-type: '① ';">
                      事前に利用者の承諾を得た範囲内で閲覧する場合。
                    </li>
                    <li style="list-style-type: '② ';">
                      システム障害の解析目的のために必要な範囲で閲覧する場合。
                    </li>
                    <li style="list-style-type: '③ ';">
                      システム利用状況の把握目的のために必要な範囲で閲覧する場合。
                    </li>
                    <li style="list-style-type: '④ ';">
                      法令に基づき必要な範囲で閲覧する場合。
                    </li>
                  </ol>
                  また、法令に基づく場合を除き、保存ファイルを第三者に開示・漏洩いたしません。
                </li>
                <li style="list-style-type: '３．';">
                  エプソンは、システムに障害が生じ、保存ファイルが滅失したことを知ったときには、速やかにシステムを修理し、保存ファイルの復旧に努めます。ただし、重大な障害の場合は、修理・復旧に時間を要す場合があります。また、修理・復旧が不可能な場合やコンピューターウイルス等の有害な情報の感染防止または制御の観点からエプソンが必要と判断した場合には、本サービスの提供を中止することがあります。
                </li>
                <li style="list-style-type: '４．';">
                  保存ファイルに関するエプソンの責任は、前三項に定める内容が全てとします。
                </li>
                <li style="list-style-type: '５．';">
                  エプソンは、利用者がシステム上に保存された保存ファイルの内容について、いかなる保証も行うものではありません。万一、保存ファイルにコンピューターウイルスなどの有害な情報が含まれ、利用者に損害が生じた場合でも、エプソンは一切責任を負わないものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１５条（利用者の責任・利用上の制限）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  利用者は、サブユーザーに対して、本利用規約の内容をあらかじめご説明していただくものとし、利用者は、自己の責任においてサブユーザーに本サービスを利用させるものとします。また、利用者は、本利用規約に基づき自己が負う義務と同等の義務をサブユーザーに課し、サブユーザーによる当該義務の履行について連帯して責任を負うものとします。
                </li>
                <li style="list-style-type: '２．';">
                  利用者は、本サービスにかかるシステム、その他本サービスにより提供される情報など（以下「本製品」といいます）がエプソンまたはエプソンが許諾を受けている第三者の財産であることを認識し、エプソンまたは当該第三者に無断で転載、転用、改変、リバースエンジニアリング、逆コンパイル、逆アセンブル、知的財産権に関する表示の削除、変更、隠蔽、不明瞭化をしたり、法令および本利用規約にて禁止される行為を行なったりしないものとします。
                </li>
                <li style="list-style-type: '３．';">
                  利用者は、本製品に不具合が発生した場合に死亡、重大な人身事故、または重大な物理的損害もしくは環境の破壊につながるようなアプリケーションまたは環境において本製品を使用しないものとします。
                </li>
                <li style="list-style-type: '４．';">
                  利用者は、利用者の責任と負担において、インターネットを利用するために必要なハードウェア、ソフトウェアおよび回線などの利用環境を準備していただくものとします。なお、エプソンは利用者の利用環境の準備のためのサポートまたは問い合せなどについては一切対応いたしません。
                </li>
                <li style="list-style-type: '５．';">
                  利用者は、本サービスに関して次の行為を行わないものとします。
                  <ol>
                    <li style="list-style-type: '① ';">
                      第１条に定める利用申込みの際、虚偽の情報を連絡する行為。
                    </li>
                    <li style="list-style-type: '② ';">
                      第９条に定めるユーザー作成の際、虚偽の情報を登録する行為。
                    </li>
                    <li style="list-style-type: '③ ';">
                      第８条に定める利用料金の支払遅延や支払債務の履行遅延または不履行。
                    </li>
                    <li style="list-style-type: '④ ';">
                      利用者自身または他の利用者のマイページのお客様番号およびパスワードならびにクラウドフォルダー管理者ユーザーおよびクラウドフォルダー一般ユーザーのユーザーIDおよびパスワードを不正に使用し、或いは第三者に使用させる行為。
                    </li>
                    <li style="list-style-type: '⑤ ';">
                      エプソンまたは第三者の権利、財産、およびプライバシーを侵害する行為、もしくはエプソンおよび第三者の名誉を毀損し、または侮辱し誹謗中傷するような行為。
                    </li>
                    <li style="list-style-type: '⑥ ';">
                      コンピューターウイルス等の有害な情報などを用いてエプソンのシステムに損害を与える行為、またはエプソンの本サービスの運営を妨げる行為。
                    </li>
                    <li style="list-style-type: '⑦ ';">
                      前各号の準備行為、または前各号の行為をなす恐れのある行為。
                    </li>
                    <li style="list-style-type: '⑧ ';">
                      前各号の他、エプソンまたは第三者に不利益を与える行為、および法令、公序良俗ならびに本利用規約に違反する行為、またはその恐れのある行為。
                    </li>
                    <li style="list-style-type: '⑨ ';">
                      本サービスの趣旨にそぐわないとエプソンが判断した行為。
                    </li>
                  </ol>
                </li>

                <li style="list-style-type: '６．';">
                  利用者は、本利用規約に違反し、エプソンに損害を与えた場合、当該損害を賠償する責任を負います。
                </li>
                <li style="list-style-type: '７．';">
                  MICROSOFT REGIONAL SALES CORPORATION（以下、「MICROSOFT」といいます）は、本利用規約における利用者の義務を強制する権限および利用者の本利用規約の遵守状況を確認する権限を持つものとします。
                </li>
                <li style="list-style-type: '８．';">
                  利用者は、エプソンとMICROSOFTとの間で締結したサービスプロバイダーライセンス契約に基づき必要となるエンドユーザー情報の開示に同意するものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１６条（利用停止・終了）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  エプソンは、利用者が前条第５項各号に定める違反行為を行なった場合、本サービスの利用を停止し、または第１７条第２項に基づき本利用契約を解約することができます。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンは、前項による本サービスの利用停止・終了に伴い、利用者に損害が生じた場合でも、一切責任を負わないものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１７条（利用契約の解約）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  利用者は、エプソンに対して事前に通知することにより、本サービスの利用を中止し、本利用契約を解約することができます。ただし、この場合、エプソンおよび販売代理店は、第８条に基づき利用者が販売代理店に対して既に支払った利用料金を一切返還せず、また利用者はエプソンおよび販売代理店に対して、その返還を一切請求できません。なお、通知の方法はエプソンが別途指定する方法に従っていただくものとします。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンは、以下の場合、利用者に事前に告知することにより、本利用契約を解約することができます。この場合、エプソンおよび販売代理店は、第８条に基づき利用者が販売代理店に対して既に支払った利用料金を一切返還いたしません。
                  <ol>
                    <li style="list-style-type: '① ';">
                      利用者が第１５条第５項第１号または第２号に違反し、エプソンが前条第１項の規定に基づき、本サービスの利用を停止した後においても、利用者の違反行為が是正されない場合。
                    </li>
                    <li style="list-style-type: '② ';">
                      第１５条第５項第３号乃至第９号に定める違反行為を行った場合。
                    </li>
                    <li style="list-style-type: '③ ';">
                      本サービスの提供自体の中止を決定した場合。
                    </li>
                  </ol>
                </li>
                <li style="list-style-type: '３．';">
                  前項の規定にかかわらず、エプソンは、解約日の３０日前までに利用者に対して通知することによりいつでも本利用契約を解約することができます。この場合、エプソンは、販売代理店を通じて利用者に対し、利用者が販売代理店に支払い済みの利用料金のうち本サービスの未実施分を対象とした相当額の返還に応じるものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１８条（責任の制限・損害賠償等）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  エプソンの責に帰すべき事由により、利用者が本サービスを全く利用できない状態にあることをエプソンが知ったときから起算して、２４時間以上に渡ってその状態が継続し、これにより利用者が損害を被った場合、エプソンは、エプソンまたは販売代理店が定める方法により、利用者による当該損害の賠償請求に応じるものとします。ただし、いかなる場合においても、エプソンの責に帰すことができない事由から生じた損害、エプソンの予見の有無を問わず特別の事情から生じた損害、逸失利益についてエプソンおよび販売代理店は賠償責任を負わないものとし、また、本項に基づきエプソンおよび販売代理店が利用者に対して負担する損害賠償額は、第８条に基づき利用者が販売代理店に支払ったサービス料金の１ヶ月分相当額を上限とします。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンが利用者に対して負う責任は、前項に定めるものが全てであり、これを超えて利用者が本サービスに関して被った損害につき、エプソンは理由の如何を問わず一切責任を負いません。エプソンは、利用者に対して、法律上の契約不適合責任を含むすべての明示または黙示の保証責任および本サービスに起因する利用者の逸失利益、特別な事情から生じた損害、データ等に対する損害および第三者の権利侵害を含めて第三者により利用者に対してなされた紛争に基づく賠償責任等の一切について責任を負いません。
                </li>
                <li style="list-style-type: '３．';">
                  エプソンは、商品性、品質性および第三者の権利の非侵害の保証を含めて、本サービス、本サービスに係る知的財産権およびそれらの使用に関して、利用者に対し、明示または黙示を問わず一切の保証をしないものとします。
                </li>
                <li style="list-style-type: '４．';">
                  損害の事由の発生から起算して１年以内に損害賠償請求権を行使しない場合、エプソンに対する当該請求権は消滅するものとします。
                </li>
                <li style="list-style-type: '５．';">
                  本利用規約に特段の定めがない限り、エプソンは、利用者およびサブユーザー対して一切の保証・責任を負わないものとします。
                </li>
                <li style="list-style-type: '６．';">
                  本サービスの利用により生じる直接損害、間接損害、または結果的損害などのすべての損害について、MICROSOFTは一切保証をせず、MICROSOFTまたはそのサプライヤーは一切の賠償責任を負わないものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１９条（保存ファイルの削除）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              エプソンは、保存ファイルを保存することが不適切であると合理的に認められる事由（第１５条第５項各号に定める内容を含み、これに限定されないものとします）がある場合、利用者の事前の承諾なく保存ファイルを削除することができるものとします。エプソンは、本項に基づく保存ファイルの削除によって利用者に損害が生じた場合でも一切責任を負わないものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第２０条（再委託）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              エプソンは、利用者に対する本サービスの提供に関して必要となる業務の全部または一部をエプソンの判断にて第三者に再委託することができます。この場合、エプソンは、当該第三者に対し、第１４条第２項に定める機密保持義務と同等の義務を負わせるものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第２１条（有効期間）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本利用契約は、第３条の定めに従い本利用契約が成立をしたときから、第１７条の定めに従い本利用契約が解除されない限り、第７条に定める利用期間が満了するまで有効に存続するものとします。
                </li>
                <li style="list-style-type: '２．';">
                  本利用契約終了後も、第１１条、第１５条第１項、第６項乃至第８項、第１８条、第２２条ならびに本項の規定はなお有効に存続します。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第２２条（専属的合意管轄裁判所）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本サービスまたは本利用契約に関連して利用者とエプソンの間で紛争が生じた時は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
            </v-col>

            <v-col />
            <v-col />

            <v-col
              cols="12"
            >
              ２０２０年８月４日
            </v-col>

            <v-col />
            <v-col
              cols="12"
              style="font-weight: bold;"
            >
              別紙：エプソンが提供する会計システム
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '・';">
                  財務会計システム
                </li>
                <li style="list-style-type: '・';">
                  給与システム
                </li>
                <li style="list-style-type: '・';">
                  個人番号一括収集システム
                </li>
              </ol>
            </v-col>
            <v-col />
          </v-row>
        </div>
        <div v-if="userType === Constant.UserType.Guest">
          <!-- 顧問先ユーザー向け 利用規約 -->
          <v-row
            dense
            max-width="100"
          >
            <v-col
              cols="12"
              align="center"
              style="font-weight: bold;"
            >
              「Weplatデータ共有サービス クラウドフォルダー」利用規約
            </v-col>
            <v-col />
            <v-col
              cols="12"
            >
              セイコーエプソン株式会社およびエプソン販売株式会社（以下総称して「エプソン」といいます）は、以下の利用規約（以下「本利用規約」といいます）に基づき、「Weplatデータ共有サービス クラウドフォルダー」（以下「本サービス」といいます）を提供いたします。
            </v-col>
            
            <v-col
              v-if="$vuetify.breakpoint.xs"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.sm"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・・・・・・・・・・・・・・・
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.md"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.lg"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・
            </v-col>
            <v-col
              v-if="$vuetify.breakpoint.xl"
              cols="12"
              align="center"
            >
              ・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・・
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１条（ユーザー作成）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本サービスの利用を希望されるお客様は、本利用規約を注意してお読みいただき、本サービスを利用するお客様の従業員（以下「サブユーザー」といいます）の個人情報（以下「ユーザー情報」といいます）のご登録、ならびに本サービスの利用に際して使用するユーザーIDおよびパスワードの設定を含むユーザー作成手続き（以下「ユーザー作成」といいます）を行っていただきます。このユーザー作成が完了した時点で、お客様は本利用規約のすべての条件に拘束され、従うことに同意いただいたものとみなさせていただきます。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第２条（本サービスの概要）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本サービスは、別紙に掲げるエプソンが提供する会計システム（以下「会計システム」といいます）および本サービスを利用することにつき別途エプソンより許諾を受けている会計事務所（その従業員を含み、以下総称して「会計事務所」といいます）から、本サービスの利用に関する招待メールを受領し、第３条の定めに基づき本利用契約が成立したお客様（以下「利用者」といいます）に対し、エプソンが無償にて提供するサービスです。
                </li>
                <li style="list-style-type: '２．';">
                  利用者は、本サービスにより本サービスで利用可能な電子ファイルをエプソンが運営するサーバー上にインターネットを通じて保存し、これを同じくインターネットを通じて会計事務所と共有等して利用することができます。
                </li>
                <li style="list-style-type: '３．';">
                  エプソンは、本サービスについて、利用者の事前の許可なく仕様を変更する場合があります。エプソンは、利用者が本利用規約に同意した時点におけるサービス内容を永続的に保証するものではありません。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第３条（利用契約の成立）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本サービスについての利用契約（以下「本利用契約」といいます）は、次項に定める場合を除き、お客様が第１条に定めるユーザー作成を完了した時点をもって成立するものとします。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンは、次の場合には、お客様との本利用契約の成立を承諾しないことがあります。
                  <ol>
                    <li style="list-style-type: '① ';">
                      利用者が、第１条に定めるユーザー作成にあたり、虚偽の内容を登録したとき。
                    </li>
                    <li style="list-style-type: '② ';">
                      利用者が、過去にエプソンが提供する他のサービスにおける料金未払いや不正使用などにより、エプソンから利用契約の解除または利用停止処分を受けていることが判明したとき。
                    </li>
                    <li style="list-style-type: '③ ';">
                      その他、利用者との間で本利用契約を成立させることが不適切であると合理的に認められる事由があるとエプソンが判断したとき。
                    </li>
                  </ol>
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第４条（本サービスの利用）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本サービスの提供時間は、０：００～２４：００とします。ただし、システムメンテナンスなどのために一時的に本サービスを停止することがあります。この場合、エプソンは利用者に対し、本サービスを停止する日時について事前に告知いたします。
                </li>
                <li style="list-style-type: '２．';">
                  前項にかかわらず、天災地変、停電または回線の不良などの緊急やむを得ない場合には、事前告知を行うことなく本サービスを停止することがあります。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第５条（利用規約の変更）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本利用規約は、エプソンにより、利用者の承諾を得ることなく変更されることがあります。その場合、エプソンは、利用者に対し変更内容の告知を行います。
                </li>
                <li style="list-style-type: '２．';">
                  変更後の利用規約は、当該利用規約に記載する日から効力を生じ、当該記載日より本サービスの利用条件は、変更後の利用規約によるものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第６条（告知の方法）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本利用規約におけるエプソンから利用者への告知は、本サービスのお知らせ画面への掲載や、利用者への電子メールによる通知など、エプソンが適当と判断する方法により実施するものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第７条（利用期間）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本サービスの利用期間は、会計データを共有する会計事務所に対し、別途エプソンが許諾している本サービスの利用期間に従うものとします。なお、エプソンが、会計事務所に対する本サービスの提供を終了した場合、または会計データを共有する会計事務所が、利用者との本サービスの利用を終了した場合には、利用者による本サービスの利用も自動的に終了するものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第８条（ユーザーIDおよびパスワード）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              利用者は、第１条に定めるユーザーIDおよびパスワードを使用して本サービスを利用することができます。利用者は善良なる管理者の注意義務をもってユーザーIDおよびパスワードを管理し、利用するものとします。万一、利用者によるユーザーIDおよびパスワードの管理もしくは利用などが不適切であったことが原因で利用者に不利益が生じた場合であっても、エプソンは一切責任を負わないものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第９条（ご入力情報の変更）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              利用者は、自己のユーザー情報に変更が生じた場合には、速やかに所定の方法にて変更していただくものとします。利用者が変更を怠ったことにより、損害を被った場合であっても、エプソンは一切責任を負わないものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１０条（個人情報の保護）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              エプソンは、利用者およびサブユーザーによりご登録されたユーザー情報、その他本サービスの提供の過程で知り得た個人情報を、エプソンのホームページ上で別途掲載する
              <a
                href="https://www.epson.jp/products/ac/privacy_statement/weplat.htm"
                target="_blank"
                rel="noopener"
              >『「ウェプラット・クラウドサービス」における個人情報の取扱について（プライバシーステートメント）』</a>
              に従い、取り扱うものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１１条（権利譲渡の禁止）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              利用者は、本サービスの利用者たる資格について、有償・無償を問わず第三者に譲渡または貸与することはできません。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１２条（本サービスの提供区域）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本サービスの提供区域は、日本国内に限定されるものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１３条（システムの管理・責任）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  エプソンは、善良なる管理者の注意義務をもって、本サービスを運営するサーバーなどのシステム（以下「システム」といいます）を維持し、システム上のデータ（以下「保存ファイル」といいます）の保全に努めるものとします。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンは、保存ファイルを利用者の機密情報として善良なる管理者の注意義務をもって管理します。エプソンは、以下の各号に定める場合を除き、保存ファイルの内容を閲覧いたしません。
                  <ol>
                    <li style="list-style-type: '① ';">
                      事前に利用者の承諾を得た範囲内で閲覧する場合。
                    </li>
                    <li style="list-style-type: '② ';">
                      システム障害の解析目的のために必要な範囲で閲覧する場合。
                    </li>
                    <li style="list-style-type: '③ ';">
                      システム利用状況の把握目的のために必要な範囲で閲覧する場合。
                    </li>
                    <li style="list-style-type: '④ ';">
                      法令に基づき必要な範囲で閲覧する場合。
                    </li>
                  </ol>
                  また、法令に基づく場合を除き、保存ファイルを第三者に開示・漏洩いたしません。
                </li><li style="list-style-type: '３．';">
                  エプソンは、システムに障害が生じ、保存ファイルが滅失したことを知ったときには、速やかにシステムを修理し、保存ファイルの復旧に努めます。ただし、重大な障害の場合は、修理・復旧に時間を要す場合があります。また、修理・復旧が不可能な場合やコンピューターウイルス等の有害な情報の感染防止または制御の観点からエプソンが必要と判断した場合には、本サービスの提供を中止することがあります。
                </li>
                <li style="list-style-type: '４．';">
                  保存ファイルに関するエプソンの責任は、前三項に定める内容が全てとします。
                </li>
                <li style="list-style-type: '５．';">
                  エプソンは、利用者がシステム上に保存された保存ファイルの内容について、いかなる保証も行うものではありません。万一、保存ファイルにコンピューターウイルスなどの有害な情報が含まれ、利用者に損害が生じた場合でも、エプソンは一切責任を負わないものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１４条（利用者の責任・利用上の制限）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  利用者は、本利用契約を締結する者が有効な締結権限を有していることを保証します。
                </li>
                <li style="list-style-type: '２．';">
                  利用者は、サブユーザーに対して、本利用規約の内容をあらかじめご説明していただくものとし、利用者は、自己の責任においてサブユーザーに本サービスを利用させるものとします。また、利用者は、本利用規約に基づき自己が負う義務と同等の義務をサブユーザーに課し、サブユーザーによる当該義務の履行について連帯して責任を負うものとします。
                </li>
                <li style="list-style-type: '３．';">
                  利用者は、本サービスにかかるシステム、その他本サービスにより提供される情報など（以下「本製品」といいます）がエプソンまたはエプソンが許諾を受けている第三者の財産であることを認識し、エプソンまたは当該第三者に無断で転載、転用、改変、リバースエンジニアリング、逆コンパイル、逆アセンブル、知的財産権に関する表示の削除、変更、隠蔽、不明瞭化をしたり、法令および本利用規約にて禁止される行為を行なったりしないものとします。
                </li>
                <li style="list-style-type: '４．';">
                  利用者は、本製品に不具合が発生した場合に死亡、重大な人身事故、または重大な物理的損害もしくは環境の破壊につながるようなアプリケーションまたは環境において本製品を使用しないものとします。
                </li>
                <li style="list-style-type: '５．';">
                  利用者は、利用者の責任と負担において、インターネットを利用するために必要なハードウェア、ソフトウェアおよび回線などの利用環境を準備していただくものとします。なお、エプソンは利用者の利用環境の準備のためのサポートまたは問い合せなどについては一切対応いたしません。
                </li>
                <li style="list-style-type: '６．';">
                  利用者は、本サービスに関して次の行為を行わないものとします。
                  <ol>
                    <li style="list-style-type: '① ';">
                      第１条に定めるユーザー作成の際に、虚偽の情報を登録する行為。
                    </li>
                    <li style="list-style-type: '② ';">
                      他の利用者のユーザーIDおよびパスワードを不正に使用する行為または利用者のユーザーIDおよびパスワードを第三者に使用させる行為。
                    </li>
                    <li style="list-style-type: '③ ';">
                      エプソンまたは第三者の権利、財産、およびプライバシーを侵害する行為、もしくはエプソンおよび第三者の名誉を毀損し、または侮辱し誹謗中傷するような行為。
                    </li>
                    <li style="list-style-type: '④ ';">
                      コンピューターウイルスなどの有害な情報を用いてエプソンのシステムに損害を与える行為、またはエプソンの本サービスの運営を妨げる行為。
                    </li>
                    <li style="list-style-type: '⑤ ';">
                      前各号の準備行為、または前各号の行為をなす恐れのある行為。
                    </li>
                    <li style="list-style-type: '⑥ ';">
                      前各号の他、エプソンまたは第三者に不利益を与える行為、および法令、公序良俗ならびに本利用規約に違反する行為、またはその恐れのある行為。
                    </li>
                    <li style="list-style-type: '⑦ ';">
                      本サービスの趣旨にそぐわないとエプソンが判断した行為。
                    </li>
                  </ol>
                </li>
                <li style="list-style-type: '７．';">
                  利用者は、本利用規約に違反し、エプソンに損害を与えた場合、当該損害を賠償する責任を負います。
                </li>
                <li style="list-style-type: '８．';">
                  MICROSOFT REGIONAL SALES CORPORATION（以下、「MICROSOFT」といいます）は、本利用規約における利用者の義務を強制する権限および利用者の本利用規約の遵守状況を確認する権限を持つものとします。                  
                </li>
                <li style="list-style-type: '９．';">
                  利用者は、エプソンとMICROSOFTとの間で締結したサービスプロバイダーライセンス契約に基づき必要となるエンドユーザー情報の開示に同意するものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１５条（利用停止・終了）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  エプソンは、利用者が前条第６項各号に定める違反行為を行なった場合、本サービスの利用を停止し、または第１６条第２項に基づき本利用契約を解約することができます。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンは、前項による本サービスの利用停止・終了に伴い、利用者に損害が生じた場合でも、一切責任を負わないものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１６条（利用契約の解約）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  利用者は、エプソンに対して事前に通知することにより、本サービスの利用を中止し、本利用契約を解約することができます。なお、通知の方法はエプソンが別途指定する方法に従っていただくものとします。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンは、以下の場合、利用者に事前に告知することにより、本利用契約を解除または解約することができます。
                  <ol>
                    <li style="list-style-type: '① ';">
                      利用者が第１４条第６項第１号に違反し、エプソンが前条第１項の規定に基づき本サービスの利用を停止した後においても、利用者の違反行為が是正されない場合。
                    </li>
                    <li style="list-style-type: '② ';">
                      利用者が第１４条第６項第２号乃至第７号に定める違反行為を行った場合。
                    </li>
                    <li style="list-style-type: '③ ';">
                      本利用契約を締結した者に有効な契約締結権限がないことが判明した場合。
                    </li>
                    <li style="list-style-type: '④ ';">
                      エプソンが本サービスの提供自体の中止を決定した場合。
                    </li>
                  </ol>
                </li>
                <li style="list-style-type: '３．';">
                  前項の規定にかかわらず、エプソンは、解約日の３０日前までに利用者に対して通知することによりいつでも本利用契約を解約することができます。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１７条（責任の制限・損害賠償等）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  エプソンは、利用者に対して、法律上の契約不適合責任を含むすべての明示または黙示の保証責任および本サービスに起因する利用者の逸失利益、特別な事情から生じた損害、データ等に対する損害および第三者の権利侵害を含めて第三者により利用者に対してなされた紛争に基づく賠償責任等の一切について責任を負いません。
                </li>
                <li style="list-style-type: '２．';">
                  エプソンは、商品性、品質性および第三者の権利の非侵害の保証を含めて、本サービス、本サービスに係る知的財産権およびそれらの使用に関して、利用者に対し、明示または黙示を問わず一切の保証をしないものとします。
                </li>
                <li style="list-style-type: '３．';">
                  本利用規約に特段の定めがない限り、エプソンは、利用者およびサブユーザーに対して一切の保証・責任を負わないものとします。
                </li>
                <li style="list-style-type: '４．';">
                  本サービスの利用により生じる直接損害、間接損害、または結果的損害などのすべての損害について、MICROSOFTは一切保証をせず、MICROSOFTまたはそのサプライヤーは一切の賠償責任を負わないものとします。
                </li>
              </ol>
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１８条（保存ファイルの削除）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              エプソンは、保存ファイルを保存することが不適切であると合理的に認められる事由（第１４条第６項各号に定める内容を含み、これに限定されないものとします）がある場合、利用者の事前の承諾なく保存ファイルを削除することができるものとします。エプソンは、本項に基づく保存ファイルの削除によって利用者に損害が生じた場合でも一切責任を負わないものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第１９条（再委託）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              エプソンは、利用者に対する本サービスの提供に関して必要となる業務の全部または一部をエプソンの判断にて第三者に再委託することができます。この場合、エプソンは、当該第三者に対し、第１３条第２項に定める機密保持義務と同等の義務を負わせるものとします。
            </v-col>

            <v-col />
            <v-col
              cols="12"
            >
              第２０条（有効期間）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '１．';">
                  本利用契約は、第３条の定めに従い本利用契約が成立をしたときから、第１６条の定めに従い本利用契約が解除されない限り、第７条に定める利用期間が満了するまで有効に存続するものとします。
                </li>
                <li style="list-style-type: '２．';">
                  本利用契約終了後も、第１０条、第１４条第１項、第２項、第７項乃至第９項、第１７条、第２１条ならびに本項の規定はなお有効に存続します。
                </li>
              </ol>
            </v-col>

            <v-col
              cols="12"
            >
              第２１条（専属的合意管轄裁判所）
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              本サービスまたは本利用契約に関連して利用者とエプソンの間で紛争が生じた時は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
            </v-col>

            <v-col />
            <v-col />

            <v-col
              cols="12"
            >
              ２０２０年８月４日
            </v-col>

            <v-col />
            <v-col
              cols="12"
              style="font-weight: bold;"
            >
              別紙：エプソンが提供する会計システム
            </v-col>
            <v-col
              cols="12"
              style="padding-left:20px;"
            >
              <ol>
                <li style="list-style-type: '・';">
                  財務会計システム
                </li>
                <li style="list-style-type: '・';">
                  給与システム
                </li>
                <li style="list-style-type: '・';">
                  個人番号一括収集システム
                </li>
              </ol>
            </v-col>
            <v-col />
          </v-row>
        </div>
      </v-card>
    </v-card>
    <v-row
      dense
      max-width="100"
      align="center"
    >
      <v-col
        cols="12"
        align="center"
      >
        <v-checkbox
          v-model="agreeflg"
          :ripple="false"
          label="利用規約に同意する"
        />
        <v-btn
          color="primary"
          :disabled="agreeButtonDisabled"
          @click="clickNext();"
        >
          次へ
        </v-btn>
      </v-col>
      <v-col
        v-if="dispTopLinkFlg"
        cols="12"
        align="center"
      >
        <a
          href="/"
        >
          トップページへ戻る
        </a>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>

import {Constant} from '../amplify_com.js';

export default {
  name: 'TermsOfService',
  props: {
    index: {
      type: Number,
      required: false,
      default: 0,
    },
    userType: {
      type: Number,
      required: false,
      default: 1,
    },
    dispTopLinkFlg: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    Constant :Constant, // template内で定数クラスを使用するため
    agreeflg: false,
    agreeButtonDisabled: true,
  }),
  watch: {
    agreeflg(newAgreeflg) {
      if(newAgreeflg){
        this.agreeButtonDisabled = false;
      } else {
        this.agreeButtonDisabled = true;
      }
    },
  },
  methods: {
    clickNext() {
      if(this.agreeflg){
        const termsOfServiceResult = {
          agreeflg : this.agreeflg,
          index : this.index,
        };
        this.$emit('termsOfServiceClickNext', termsOfServiceResult);
      }
    },
  }
};
</script>

<style>
</style>